
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"255.984","cy":"492","r":"20"}}),_c('path',{attrs:{"d":"M412.979 155.775C412.321 69.765 342.147 0 255.984 0c-86.57 0-157 70.43-157 157 0 11.046 8.954 20 20 20s20-8.954 20-20c0-64.514 52.486-117 117-117s117 52.486 117 117c0 .356.009.71.028 1.062a116.936 116.936 0 01-71.12 106.661c-40.038 17.094-65.908 56.675-65.908 100.839V412c0 11.046 8.954 20 20 20s20-8.954 20-20v-46.438c0-28.117 16.334-53.258 41.614-64.051a156.884 156.884 0 0095.418-144.516c0-.41-.013-.816-.037-1.22z"}})])
          )
        }
      }
    